import { ActivatedRoute, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AddInternshipDialogComponent } from '../../modal/add-internship-dialog/add-internship-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewQuestionnaireTraineeDialogComponent } from '../../modal/view-questionnaire-trainee-dialog/view-questionnaire-trainee-dialog.component';
import { CompanyService } from '../../service/company.service';
import { Internship } from '../../models/internship';
import { EditInternshipDialogComponent } from '../../modal/edit-internship-dialog/edit-internship-dialog.component';
import { HttpClient } from '@angular/common/http';
import { ConfirmationnDialogComponent } from '../../modal/confirmation-dialog/confirmation-dialog.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AlertService } from '../../service/alert.service';
import { InfoQuestionnaireDialogComponent } from '../../modal/info-questionnaire-dialog/info-questionnaire-dialog.component';
import { ViewInternshipDialogComponent } from '../../modal/view-internship-dialog/view-internship-dialog.component';
import { CreateAvailableInternshipAvailability, InternshipsService } from '../../service/internships.service';
import { CreateAvailableInternshipDialogComponent } from '../../modal/create-available-internship-dialog/create-available-internship-dialog.component';
import { AvailableInternship } from '../../models/availableInternship.models';
import { ViewAvailableInternshipDialogComponent } from '../../modal/view-available-internship-dialog/view-available-internship-dialog.component';
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { CommonModule } from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-internships',
  standalone: true,
  templateUrl: './internships.component.html',
  styleUrl: './internships.component.css',
  providers: [  ],
  imports: [MatIcon, MatProgressSpinner, AlertMessageComponent, CommonModule, MatTooltipModule, ReactiveFormsModule, MatTableModule, MatPaginator, FormsModule, TranslateModule]
})

export class InternshipsComponent implements OnInit{

  constructor(public dialog: MatDialog, private companyService: CompanyService,
    private route: Router, private alertService: AlertService, private internshipsService: InternshipsService,
    private translate: TranslateService) {}

  allData: Internship[] = [];
  displayedColumns: string[] = [
    'select',
    'internshipTitle',
    'position',
    /* 'department', */
    'country',
    'duration',
    'status',
    'trainee',
    'supervisor',
    'questionnaire', 
    'actions'         
  ];
  dataSource = new MatTableDataSource<Internship>([]);
  isLoading = false;
  tutorFilter: string = '';

  selection = new SelectionModel<Internship>(true, []);
  filterValue: string = '';
  statusFilter: string = '';
  questionnaireCompiledFilter: string = '';  
  globalFilter: string = '';
  startDateFilter: Date | null = null;
  endDateFilter: Date | null = null;
  isCreateAvailable = false;
  createTooltipReasonKey = '';
  createTooltipReasonParams: Record<string, string> = {};
  isAddAvailable = false;
  addTooltipKey = '';

  dateRange = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null)
  });


  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }


  ngOnInit() {

    this.isLoading = true;
    this.loadInternships();
    
    this.internshipsService.canCreateAvailableInternship().subscribe(
      (   res: CreateAvailableInternshipAvailability) => {
        this.isCreateAvailable = res.canCreate;
        this.createTooltipReasonKey = res.reason || '';
        this.createTooltipReasonParams = res.reasonParams ?? {};
      },
      (    err: any) => {
        this.isCreateAvailable = false;
        this.createTooltipReasonKey = 'internships.create-tooltip-error';
        this.createTooltipReasonParams = {};
      }
    );

  this.dateRange.valueChanges.subscribe(value => {
    if (value?.start) {
      this.startDateFilter = new Date(value.start);
    } else {
      this.startDateFilter = null;
    }

    if (value?.end) {
      const end = new Date(value.end);
      this.endDateFilter = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999);
    } else {
      this.endDateFilter = null;
    }

    this.applyFilter();
  });
  }

  openCreateAvailableInternshipDialog(): void {
    if (!this.isCreateAvailable) return; 

    const dialogRef = this.dialog.open(CreateAvailableInternshipDialogComponent, {
      panelClass:'custom-dialog-create-available-internship',
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
      /* console.log('La dialog è stata chiusa'); */
    });
  }

  loadInternships(): void {
    this.companyService.getInternshipsByCompany().subscribe({
      next: (data) => {
        this.allData = data;
        this.dataSource.data = this.allData;
        this.isLoading = false;
        // Controlla se ci sono internship disponibili
        this.checkAvailableInternships();
      },
      error: (err) => {
        console.error('Errore nel caricamento dei tirocini:', err);
        this.isLoading = false;
      }
    });
  }

  checkAvailableInternships(): void {
    
    this.companyService.getAvailableInternships().subscribe(
      availableInternships => {
        this.isAddAvailable = availableInternships.length > 0;
        this.addTooltipKey = !this.isAddAvailable ? 'internships.add-tooltip-missing-available' : '';
      }
    );

  }


  openAddInternshipDialog(): void {
    if (!this.isAddAvailable) return;

    const dialogRef = this.dialog.open(AddInternshipDialogComponent, {
      panelClass:'custom-dialog-add-internship',
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  openViewQuestionnaireDialog(): void {
    const dialogRef = this.dialog.open(ViewQuestionnaireTraineeDialogComponent, {
      panelClass:'custom-dialog-view-questionnaire',
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: Internship): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  applyFilter() {
    const globalFilterLower = (this.globalFilter || '').trim().toLowerCase();
    const statusValue = this.statusFilter || '';
    const questionnaireValue = this.questionnaireCompiledFilter;
    const startFilter = this.startDateFilter;
    const endFilter = this.endDateFilter;

    const filteredData = this.allData.filter(data => {
      const internshipStart = data.startDate ? new Date(data.startDate) : null;
      const internshipEnd = data.endDate ? new Date(data.endDate) : null;

      // Global search
      const matchesGlobal =
        !globalFilterLower ||
        (data.traineeName || '').toLowerCase().includes(globalFilterLower) ||
        (data.traineeLastname || '').toLowerCase().includes(globalFilterLower) ||
        (data.traineeEmail || '').toLowerCase().includes(globalFilterLower) ||
        (data.supervisorFirstname || '').toLowerCase().includes(globalFilterLower) ||
        (data.supervisorLastname || '').toLowerCase().includes(globalFilterLower) ||
        (data.supervisorEmail || '').toLowerCase().includes(globalFilterLower) ||
        (data.availableInternshipTitle || '').toLowerCase().includes(globalFilterLower) ||
        (data.availableInternshipPosition || '').toLowerCase().includes(globalFilterLower) ||
        (data.status || '').toLowerCase().includes(globalFilterLower) ||
        (data.startDate ? new Date(data.startDate).toLocaleDateString() : '').toLowerCase().includes(globalFilterLower) ||
        (data.endDate ? new Date(data.endDate).toLocaleDateString() : '').toLowerCase().includes(globalFilterLower);

      // Status
      const matchesStatus = !statusValue || (data.status || '').toLowerCase() === statusValue.toLowerCase();

      // Questionnaire
      const matchesQuestionnaire =
        !questionnaireValue ||
        (questionnaireValue === 'YES' && data.questionnaireCompiled) ||
        (questionnaireValue === 'NO' && !data.questionnaireCompiled);

      // Date range
      const matchesDate =
        (!startFilter || (internshipStart && internshipStart >= startFilter)) &&
        (!endFilter || (internshipEnd && internshipEnd <= endFilter));

      return matchesGlobal && matchesStatus && matchesQuestionnaire && matchesDate;
    });

    this.dataSource.data = filteredData;
    this.selection.clear();

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  infoDetailQuestionnaire(internship: Internship) {
    const dialogRef = this.dialog.open(InfoQuestionnaireDialogComponent, {
      panelClass:'custom-dialog-info-questionnaire',
      data: internship,
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('La dialog è stata chiusa');
    });
  }

  viewInternship(internship: Internship): void {
    const dialogRef = this.dialog.open(ViewInternshipDialogComponent, {
      panelClass:'custom-dialog-view-internship',
      data: internship,
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('La dialog è stata chiusa');
    });
  }


  editInternship(internship: Internship): void {
    const dialogRef = this.dialog.open(EditInternshipDialogComponent, {
      panelClass:'custom-dialog-edit-internship',
      data: internship,
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('La dialog è stata chiusa');
    });
  }

  deleteInternship(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
    width: '400px',
    data: { message: this.translate.instant('internships.confirm-delete-trainee') }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result){
        this.companyService.deleteInternship(id).subscribe({
          next: (res) => {
            this.alertService.success(res)
            this.loadInternships();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          },
          error: (err) => {
            console.error('Errore durante l\'eliminazione:', err);
            this.alertService.error(err.error)
          }
        });
      }
    });
  }

  viewQuestionnaire(internship: any) {
    this.route.navigate(['/view-questionnaire', internship.userId], 
                        { queryParams: { returnUrl: '/internships' } });
  }

  clearFilters(): void {
    this.filterValue = '';
    this.statusFilter = '';
    this.tutorFilter = '';
    this.globalFilter = '';
    this.questionnaireCompiledFilter = '';
    this.startDateFilter = null;
    this.endDateFilter = null;

    this.dateRange.reset({ start: null, end: null });

    this.applyFilter();
  }

}
